import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/default/images/logo-LINE_PAY.svg'


const _hoisted_1 = { class: "shadow-lg rounded-xl border-t-4 border-line bg-white" }
const _hoisted_2 = { class: "rounded-xl overflow-hidden relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "flex justify-center" }, [
      _createElementVNode("img", { src: _imports_0 })
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "inner-frame pointer-events-none" }, null, -1)),
      _createElementVNode("div", null, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ]))
}